import React, { useContext } from 'react';
import {
  Contentx,
  Menu,
  Header,
} from './layout';
import GeneralProvider from '../context/config.context';
import { ConfigContextUtils } from '../context/contextUtils.context';

const Main = () => {

  const { preloader } = useContext(ConfigContextUtils);
  
  return(
    <>
    <GeneralProvider>
     {preloader ? 
      <div className="loading">Cargando...</div>
     : null}
     <div className="container-fluid m-0 p-0">
       <Header/>
       <Menu/>
       <div className="content-general">
          <Contentx />
       </div>
     </div>
     </GeneralProvider>
    </>
  )
}

export default Main;